import React from "react";
import { Controller } from "react-hook-form";
import { FaFilePdf } from "react-icons/fa";
import helpers from "utils/helpers";
import ImageModal from "./ImageModal";
const FileUploadInput = ({ label, name, control, fileType, defaultUrl, isView, rules, accept = "image/*" }) => {

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const hasNewFile = value ? true : false
                const previewUrl = helpers.ternaryCondition(hasNewFile, helpers.getFileORUrl(value), defaultUrl)
                return (
                    <>
                        {previewUrl ? (
                            <div className="">
                                <figure className="w-[100px] h-[90px] relative overflow-hidden rounded-lg block mb-2">
                                    {helpers.ternaryCondition(fileType == "pdf",
                                        <a
                                            href={previewUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-16 h-30 rounded-xl flex items-center justify-center text-3xl cursor-pointer transition"
                                        >
                                           <FaFilePdf className="h-14 w-24 " />
                                        </a> ,
                                        <ImageModal
                                            url={previewUrl}
                                            title={'View Image'}
                                        >
                                            <img className="h-20 w-40 rounded-2xl shadow-lg border border-gray-200" src={previewUrl} alt="uploadImg" onError={(e) => { e.target.onerror = null; e.target.src = "/images/no-images.png"; }}
                                            />
                                        </ImageModal>

                                    )}
                                    {helpers.andOperator(!defaultUrl && !isView, <button className="absolute top-2 right-2" onClick={() => onChange(null)}>
                                        <img src="/images/croseImg.svg" />
                                    </button>)}
                                </figure>
                            </div>

                        ) : (
                            <div>
                                <div className="w-[100px] h-[60px] relative bg-[#F3F3F3] border border-[#DFDFDF] rounded-lg p-4 flex items-center justify-center mb-2">
                                    <span >
                                        <img
                                            src="/images/uploadBack.svg"
                                            alt="uploadBack"
                                        />
                                    </span>
                                    <input
                                        type="file"
                                        accept={accept}
                                        onChange={(e) => onChange(e?.target?.files)}
                                        className="absolute top-0 bottom-0 left-0 right-0 opacity-0"
                                    />
                                </div>
                                <h5 className="text-sm text-[#A5A5A5] block text-center">
                                    {label}
                                </h5>
                            </div>

                        )}

                    </>
                )
            }}
        />
    );
};

export default FileUploadInput;
